import {
    SET_BILLINGS,
    SET_ACCOUNT_BILLINGS,
    SET_ACCOUNT_PRICINGS,
    SET_BILLING_EXPORT_SCHEDULES
} from 'app/actions/types';

import {
    getBillings as getBillingsSvc,
    getAccountBilling as getAccountBillingSvc,
    getAccountPricings as getAccountPricingsSvc,
    getBillingExportScheds as getBillingExportSchedsSvc
} from 'app/services/billings';

export const getBillings = params => async dispatch => {
    let billings = await getBillingsSvc(params);

    if (billings) {
        dispatch({
            type: SET_BILLINGS,
            payload: billings.params
        });
    }

    return billings;
}

export const setBillingParams = params => async dispatch => {
  dispatch({
    type: SET_BILLINGS,
    payload: params
  });
}

export const getAccountBillings = params => async dispatch => {
    let accountBillings = await getAccountBillingSvc(params);

    if (accountBillings) {
        dispatch({
            type: SET_ACCOUNT_BILLINGS,
            payload: accountBillings.params
        });
    }

    return accountBillings;
}

export const setAccountBillingParams = params => async dispatch => {
  dispatch({
    type: SET_ACCOUNT_BILLINGS,
    payload: params
  });
}

export const getAccountPricings = params => async dispatch => {
    let accountPricings = await getAccountPricingsSvc(params);

    if (accountPricings) {
        dispatch({
            type: SET_ACCOUNT_PRICINGS,
            payload: accountPricings.params
        });
    }

    return accountPricings;
}

export const setAccountPricingParams = params => async dispatch => {
  dispatch({
    type: SET_ACCOUNT_PRICINGS,
    payload: params
  });
}

export const getBillingExportScheds = params => async dispatch => {
    let exportScheds = await getBillingExportSchedsSvc(params);

    if (exportScheds) {
        dispatch({
            type: SET_BILLING_EXPORT_SCHEDULES,
            payload: exportScheds.params
        });
    }

    return exportScheds;
}

export const setBillingExportSchedParams = params => async dispatch => {
  dispatch({
    type: SET_BILLING_EXPORT_SCHEDULES,
    payload: params
  });
}
